import { z } from "zod";

export const matchingApiRequestSchema = z.object({
    listingId: z.string().min(1),
    comment: z.string().optional(),
    mode: z.enum(["deterministic", "llm"]).optional().catch(undefined),
});
